/**
 * Tiny utilities for /lab/* client-side routing.
 * We avoid pulling in react-router — this app uses window.location-based
 * routing throughout (see src/lender/App.js).
 */

export const LAB_PREFIX = "/lab";

export const parseLabRoute = (pathname = window.location.pathname) => {
    const path = pathname.toLowerCase();
    if (!path.startsWith(LAB_PREFIX)) return { route: "external" };

    const rest = path.slice(LAB_PREFIX.length).replace(/^\/+|\/+$/g, "");
    if (!rest) return { route: "dashboard" };

    const [head, ...tail] = rest.split("/");
    switch (head) {
        case "submit":         return { route: "submit" };
        case "experiments":    return tail.length === 0
            ? { route: "experiments" }
            : { route: "experiment-detail", runId: decodeURIComponent(tail[0]) };
        case "recommendations": return { route: "recommendations" };
        case "history":        return { route: "history" };
        case "settings":       return { route: "settings" };
        case "upgrade":        return { route: "upgrade" };
        default:               return { route: "not-found" };
    }
};

export const navigate = (to) => {
    if (typeof window === "undefined") return;
    if (window.location.pathname === to) return;
    // Signal the top progress bar that a navigation is starting. The bar
    // is also listening to popstate, but firing the explicit event lets us
    // start animating before the new route mounts (popstate is synchronous
    // with pushState, but the explicit start avoids any race with React's
    // commit phase).
    window.dispatchEvent(new Event("lab:nav-start"));
    window.history.pushState({}, "", to);
    window.dispatchEvent(new PopStateEvent("popstate"));
};

export const labHref = (segment = "") => {
    if (!segment) return LAB_PREFIX;
    return `${LAB_PREFIX}/${segment.replace(/^\//, "")}`;
};
